import * as React from 'react';
import { defaultMapState } from './map-state-context';
import { defaultEntityMapMarkersSet } from './entity-type-map-markers-context';
export var defaultMapConfig = {
  initialMapState: defaultMapState,
  mapboxStyleUrl: process.env.MAPBOX_STYLE_URL || 'mapbox://styles/mapbox/streets-v11',
  mapboxAccessToken: process.env.MAPBOX_API_KEY,
  title: process.env.MAP_TITLE || 'Global Map',
  entityTypeMapMarkers: defaultEntityMapMarkersSet,
  applyEntityTypeFilters: function () {
    return true;
  },
  groupConfig: {
    accentColor: 'primary'
  }
};
export var MapConfigContext = React.createContext(defaultMapConfig);
export var MapConfigProvider = MapConfigContext.Provider;
export var useMapConfig = function () {
  return React.useContext(MapConfigContext);
};